// From: https://firebase.google.com/docs/analytics/android/webview

declare var window: any;

export default class Analytics {

    public static PREFIX = null;

    public static logEvent(name, params = {}) {
        if (!name) {
            return;
        }

        if (this.PREFIX) name = this.PREFIX + name;

        if (window.Android && window.Android.logEvent) {
            // Call Android interface
            window.Android.logEvent(name, JSON.stringify(params));
        } else if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.analytics) {
            // Call iOS interface
            var message = {
                command: 'logEvent',
                name: name,
                parameters: params
            };
            window.webkit.messageHandlers.analytics.postMessage(message);
        } else {
            // No Android or iOS interface found
            console.log("Analytics: " + name, params);
        }
    }

    public static setUserProperty(name, value) {
        if (!name || !value) {
            return;
        }

        if (window.Android && window.Android.setUserProperty) {
            // Call Android interface
            window.Android.setUserProperty(name, value);
        } else if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.analytics) {
            // Call iOS interface
            var message = {
                command: 'setUserProperty',
                name: name,
                value: value
            };
            window.webkit.messageHandlers.analytics.postMessage(message);
        } else {
            // No Android or iOS interface found
            console.log("Analytics: " + name + " => " + value);
        }
    }
}


// WEBPACK FOOTER //
// ../lib/src/Analytics.ts